/**
 * 产品管理 微博 添加微博账号
 * author: Qian.qianchen 2018-11-14
 */
"use strict";
angular.module("weiboAccountAddModule", [])
    .controller('weiboAccountAddCtrl', ['$scope', '$modalInstance', '$validation', 'trsHttpService', function($scope, $modalInstance, $validation, trsHttpService) {
        initStatus();

        function initStatus() {
            $scope.data = {
                currUser: {
                    sinaLoginUserName: '',
                    sinaUserLoginPwd: '',
                    checkFgdAttribute: '0',
                    ISORIGINAL: 1,
                }
            }
        }
        /**
         * [checkProperty description] 是否检查稿件属性
         * @return {[type]} [description]
         */
        $scope.checkProperty = function() {
            $scope.data.currUser.checkFgdAttribute = $scope.data.currUser.checkFgdAttribute == '0' ? '1' : '0';
        };
        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            var params = {
                serviceid: "wcm61_scmaccount",
                methodname: "addSinaAccountToJson",
                sinaLoginUserName: $scope.data.currUser.sinaLoginUserName,
                sinaUserLoginPwd: $scope.data.currUser.sinaUserLoginPwd,
                checkFgdAttribute: $scope.data.currUser.checkFgdAttribute,
                ISORIGINAL: $scope.data.currUser.ISORIGINAL
            }
            $scope.accountForm.$pending = {};
            $validation.validate($scope.accountForm).success(function() {
                LazyLoad.js(["./lib/js-base64/base64.js"], function() {
                    params.sinaUserLoginPwd = Base64.encode(angular.copy($scope.data.currUser.sinaUserLoginPwd));
                    $scope.loadingPromise = trsHttpService.httpServer('/wcm/rbcenter.do', params, 'post', true).then(function(data) {
                        $modalInstance.close("success");
                    }, function(data) {
                        $modalInstance.close({data:data,checkFgdAttribute:$scope.data.currUser.checkFgdAttribute});
                    });
                });
            });
        };
    }]);